/**
 * State used in rendering MenuSplitGroup
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
